module.exports = __webpack_public_path__ + "img/engagementbox.126ea9c.jpg";